import { render, staticRenderFns } from "./groupGemsModal.vue?vue&type=template&id=c527499a&scoped=true&"
import script from "./groupGemsModal.vue?vue&type=script&lang=js&"
export * from "./groupGemsModal.vue?vue&type=script&lang=js&"
import style0 from "./groupGemsModal.vue?vue&type=style&index=0&id=c527499a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c527499a",
  null
  
)

export default component.exports